import React, { useRef, useEffect } from 'react';
import Icon from '../icon/newChart.svg';
import apiService from '../services/apiService';
import logger from '../utils/logger';
import * as appStorage from '../utils/appIndexedDB';

const GAP_PX = 16; // product-name 與 messages 內容的間距

// 頁首：WebSocket 連線測試／掛斷等（深淺模式改由側欄設定）
const PageHeader = ({
  user: _user,
  wsConnected: _wsConnected,
  wsEnabled: _wsEnabled,
  onToggleWebsocketTest,
  isMobile,
  isNewChat,
  createNewChat
}) => {
  const productNameRef = useRef(null);

  // 依 product-name 實際寬度設定 CSS 變數，縮放時 messages 仍保持在右側
  useEffect(() => {
    const el = productNameRef.current;
    if (!el) return;

    const setOffset = () => {
      const width = el.getBoundingClientRect().width;
      document.documentElement.style.setProperty('--messages-offset-left', `${width + GAP_PX}px`);
    };

    setOffset();
    const ro = new ResizeObserver(setOffset);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  const handleNewChat = () => {
    createNewChat();
  };

  const handleHangup = async () => {
    // 先嘗試查詢並關閉既有的 Livechat 房間
    try {
      const canAccessStorage = typeof window !== 'undefined';
      if (canAccessStorage) {
        const token = await appStorage.getItem('mygenie_token');
        if (token) {
          logger.info('客服', '頁首掛斷按鈕：直接呼叫關閉 Livechat 房間 API（由後端依登入帳號尋找 roomId）');
          try {
            await apiService.request('/web/cs/agent/room/close', {
              method: 'POST',
              headers: {
                'Authorization': `Bearer ${token}`,
              },
              body: JSON.stringify({}),
            });
          } catch (closeError) {
            logger.warn('客服', '頁首掛斷按鈕：關閉 Livechat 房間 API 呼叫失敗，略過錯誤', {
              error: closeError.message,
            });
          }
        }
        // 點擊掛斷時，標記目前不再使用 WebSocket
        try {
          await appStorage.setItem('nowIsWebSocket', 'false');
        } catch (storageError) {
          logger.warn('WebSocket', '頁首掛斷按鈕：設定 nowIsWebSocket 為 false 失敗，略過錯誤', {
            error: storageError.message,
          });
        }
      }
    } catch (error) {
      logger.warn('客服', '頁首掛斷按鈕：轉真人前處理既有房間失敗，略過錯誤', {
        error: error.message,
      });
    }

    // 最後仍執行原本的 WebSocket 切換/掛斷邏輯
    if (onToggleWebsocketTest) {
      onToggleWebsocketTest();
    }
  };

  let isNowWebSocket = false;
  try {
    if (typeof window !== 'undefined') {
      isNowWebSocket = appStorage.getItemSync('nowIsWebSocket') === 'true';
    }
  } catch {
    isNowWebSocket = false;
  }

  return (
    <div className="page-header">
      <div className="header-left">
        <div ref={productNameRef} className="product-name">
          <span className="product-name-en">MyBro </span>
          <span className="product-name-zh">助理小哥</span>
          <span className="product-name-en"></span>
        </div>
      </div>
      <div className="header-right">
        {isNowWebSocket && (
          <button
            onMouseDown={handleHangup}
            className="header-hangup-btn"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '8px 14px',
              borderRadius: '8px',
              border: 'none',
              background: '#dc3545',
              color: '#fff',
              cursor: 'pointer',
              fontWeight: 500,
              boxShadow: '0 1px 3px rgba(220, 53, 69, 0.35)',
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              <line x1="2" y1="2" x2="22" y2="22" />
            </svg>
            取消轉專人
          </button>
        )}
        {isMobile && !isNewChat && !isNowWebSocket && (
          <div 
            className="header-newchat-btn "
            onClick={handleNewChat}
          >
            <img src={Icon} alt="新對話" />
            <span className="tooltip">新對話</span>
          </div>
        )}
        
      </div>
    </div>
  );
};

export default PageHeader;
